import { render, staticRenderFns } from "./WelcomeModal.vue?vue&type=template&id=f0baccec&scoped=true&"
import script from "./WelcomeModal.vue?vue&type=script&lang=ts&"
export * from "./WelcomeModal.vue?vue&type=script&lang=ts&"
import style0 from "./WelcomeModal.vue?vue&type=style&index=0&id=f0baccec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0baccec",
  null
  
)

export default component.exports